import { FormControl, FormGroup, Validators } from '@angular/forms';

export class CompanyPackagePricingForm extends FormGroup<{
  id: FormControl<number | undefined>;
  CompanyId: FormControl<number | undefined | null>;
  basePackagePrice: FormControl<number | undefined | null>;
  basePackagePriceRemittance: FormControl<number | undefined | null>;
  fullPackagePrice: FormControl<number | undefined | null>;
  fullPackagePriceRemittance: FormControl<number | undefined | null>;
  premiumPackagePricePerEmployee: FormControl<number | undefined | null>;
  premiumPackagePricePerEmployeeRemittance: FormControl<
    number | undefined | null
  >;
  packageWaiverAmount: FormControl<number | undefined | null>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      CompanyId: new FormControl<number | undefined>(undefined),
      basePackagePrice: new FormControl<number | undefined>(undefined),
      basePackagePriceRemittance: new FormControl<number | undefined>(
        undefined
      ),
      fullPackagePrice: new FormControl<number | undefined>(undefined),
      fullPackagePriceRemittance: new FormControl<number | undefined>(
        undefined
      ),
      premiumPackagePricePerEmployee: new FormControl<number | undefined>(
        undefined
      ),
      premiumPackagePricePerEmployeeRemittance: new FormControl<
        number | undefined
      >(undefined),
      packageWaiverAmount: new FormControl<number | undefined>(undefined)
    });
  }
}
